<template>
  <transition name="fade">
    <Loading v-if="$store.state.loading" />
    <div class="modal-carousel-container">
      <div class="modal-carousel-wrapper">
        <div class="modal-carousel-header">
          <div class="column100 flex-space-between items-center">
            <div class="modal-carousel-header__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>
            </div>
            <div
              class="modal-carousel-header__btn-close cursor-pointer"
              @click="onClose"
            >
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div class="flex-column">
            <div class="gray900 text-bold text-18">Edit Carousel</div>
            <div class="gray600 text-14">
              Ukuran gambar untuk carousel adalah 900px x 230px
            </div>
          </div>
        </div>

        <div class="modal-carousel-content-wrapper">
          <div class="modal-carousel-content text-14">
            <div class="add-slide column100">
              <h5>Tambah Slide Baru</h5>
              <form @submit.prevent="addSlide">
                <!-- <input type="text" v-model="newSlide.alt" placeholder="" /> -->
                <label for="fileInput" class="custom-file-label column100">
                  <span>{{ selectedFileName || 'Pilih Gambar' }}</span>
                  <input
                    id="fileInput"
                    type="file"
                    ref="fileInput"
                    @change="handleFileChange"
                    accept="image/*"
                  />
                </label>
                <!-- <input type="file" ref="fileInput" @change="handleAddFileChange" accept="image/*" /> -->
                <div class="flex-row btn-add-slide-wrapper">
                  <button
                    type="button"
                    :disabled="!selectedFileName"
                    class="btn-cancel"
                    @click="cancelSelection"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="!selectedFileName"
                    class="btn-add-slide"
                  >
                    Upload
                  </button>
                </div>
              </form>
            </div>
            <div class="column100">
              <div
                v-for="(slide, index) in images"
                :key="index"
                class="card-carousel"
              >
                <div class="flex-row" style="justify-content: space-between;">
                  <h4>Slide {{ index + 1 }}</h4>
                  <button
                    class="btn-delete-slide"
                    @click="deleteSlide(slide.id, index)"
                  >
                    <!-- &times; -->
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg> -->
                    <img
                      :src="require(`~/assets/img/icons/trash-icon.png`)"
                      alt=""
                    />
                  </button>
                </div>
                <img :src="slide.image" class="img-carousel-edit" />
                <input type="text" v-model="slide.image" readonly />
                <div class="flex-row btn-manage-carousel-wrapper">
                  <div>
                    <!-- <button class="btn-edit-image" @click="editImage(index)">
                      Edit Gambar
                    </button> -->
                  </div>
                  <div class="btn-up-down">
                    <button @click="moveSlideUp(index)" :disabled="index === 0">
                      <!-- &#8593; -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                        />
                      </svg>
                    </button>
                    <button
                      @click="moveSlideDown(index)"
                      :disabled="index === images.length - 1"
                    >
                      <!-- &#8595; -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-carousel-modal">
          <button class="btn-save-carousel" @click="updateIndexing">
            Simpan Carousel
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import axios from 'axios'
export default {
  props: ['images'],
  components: {
    Loading: () => import('@/components/utils/Loading'),
  },
  data() {
    return {
      activeSlide: 0,
      // slides: [
      //   { caption: 'Slide 1', imageUrl: require(`~/assets/img/carausel/1.jpeg`) },
      //   { caption: 'Slide 2', imageUrl: require(`~/assets/img/carausel/hijau.jpg`) },
      //   { caption: 'Slide 3', imageUrl: require(`~/assets/img/carausel/pink.jpg`) }
      // ],
      newSlide: {
        alt: '',
        imageFile: null,
      },
      selectedFileName: '',
      // editingIndex: null,
      // isSelectionCanceled: false,
    }
  },
  methods: {
    onClose() {
      this.$emit('closeModalCarousel')
    },
    async addSlide() {
      this.$store.commit('setLoading', true)
      try {
        if (this.isSelectionCanceled) {
          this.newSlide.imageFile = null
          this.isSelectionCanceled = false
        } else {
          let url = `${process.env.VUE_APP_API}/api/v1/carousel/add-carousel`

          let bodyFormData = new FormData()
          this.newSlide.imageFile &&
            bodyFormData.append('carousel[]', this.newSlide.imageFile)

          const { data: response } = await axios({
            method: 'POST',
            url,
            data: bodyFormData,
          })

          if (response && response.status == 'success') {
            this.$store.commit('setLoading', false)
            const carousel = response.data
            this.$store.commit('ADD_NEW_SLIDE', {
              id: carousel.id,
              alt: `image ${carousel.id}`,
              image: `${process.env.VUE_APP_API}/file/${carousel.path}`,
              indexing: carousel.indexing,
            })

            this.newSlide = {
              alt: '',
              imageFile: null,
            }
            this.selectedFileName = ''
            this.activeSlide = 0
          }
        }
      } catch (error) {
        this.$store.commit('setLoading', false)
        alert(error?.response?.data?.message)
      }
    },
    async deleteSlide(id, index) {
      this.$store.commit('setLoading', true)
      try {
        let url = `${process.env.VUE_APP_API}/api/v1/carousel/${id}`
        const { data: response } = await axios({
          method: 'DELETE',
          url,
        })

        if (response && response.status == 'success') {
          this.$store.commit('setLoading', false)
          this.$store.commit('DELETE_SLIDE', index)
        }
      } catch (error) {
        this.$store.commit('setLoading', false)
        console.log('error: ', error)
      }
    },
    moveSlideUp(index) {
      const slide = this.images[index]
      this.images.splice(index, 1)
      this.images.splice(index - 1, 0, slide)
      this.activeSlide--

      console.log('image after move up: ', this.$store.state.slides)
      this.$store.commit('UPDATE_INDEXING')
    },
    moveSlideDown(index) {
      const slide = this.images[index]
      this.images.splice(index, 1)
      this.images.splice(index + 1, 0, slide)
      this.activeSlide++

      console.log('image after move down: ', this.$store.state.slides)
      this.$store.commit('UPDATE_INDEXING')
    },
    editImage(index) {
      const fileInput = document.createElement('input')
      fileInput.type = 'file'
      fileInput.accept = 'image/*'
      fileInput.addEventListener('change', event => {
        const file = event.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = event => {
            const imageDataUrl = event.target.result
            this.images[index].image = imageDataUrl
          }
          reader.readAsDataURL(file)
        }
      })
      fileInput.click()
    },
    handleFileChange_backup(event) {
      const file = event.target.files[0]
      if (file) {
        this.newSlide.imageFile = file
        this.selectedFileName = file.name
      } else {
        this.newSlide.imageFile = null
        this.selectedFileName = ''
      }
      console.log('file: ', file)
    },
    handleFileChange(e) {
      let fileUpload = Array.from(e.target.files)
      let fileType = fileUpload[0].type
      let fileName = fileUpload[0].name

      fileUpload['file'] = fileUpload
      fileUpload['fileName'] = fileUpload[0].name

      if (fileType.search(/jpeg|jpg|png/gi) >= 0) {
        this.newSlide.imageFile = fileUpload[0]
        this.selectedFileName = fileName
      } else {
        alert(`Jenis File ${fileType} tidak dapat di upload`)
      }
    },
    cancelSelection() {
      this.newSlide.imageFile = null
      this.selectedFileName = ''
      this.$refs.fileInput.value = ''
    },
    updateIndexing() {
      this.$store.dispatch('updateIndexing')
    },
  },
}
</script>
